// C2.3 : aucune donnee d'authentification dans les donnees de session conservees cote navigateur
// (localStorage '@accessUser' et 'userInfo', etat Redux). Le jeton n'est jamais modifie.
export const SENSITIVE_SESSION_KEYS = [
  'password', 'passwd', 'pwd', 'password_hash', 'passwordhash',
  'reset_password_token', 'reset_password_expires',
];
const SENSITIVE = new Set(SENSITIVE_SESSION_KEYS);
const MAX_DEPTH = 8;
const isPlainObject = (v) => {
  if (v === null || typeof v !== 'object') return false;
  const p = Object.getPrototypeOf(v);
  return p === Object.prototype || p === null;
};
const isContainer = (v) => Array.isArray(v) || isPlainObject(v);

export const hasSensitiveSessionData = (value, depth = 0) => {
  if (!isContainer(value) || depth > MAX_DEPTH) return false;
  if (Array.isArray(value)) return value.some((v) => hasSensitiveSessionData(v, depth + 1));
  return Object.keys(value).some(
    (k) => SENSITIVE.has(k.toLowerCase()) || hasSensitiveSessionData(value[k], depth + 1)
  );
};

export const sanitizeSessionData = (value, depth = 0) => {
  if (!isContainer(value) || depth > MAX_DEPTH) return value;
  if (Array.isArray(value)) return value.map((v) => sanitizeSessionData(v, depth + 1));
  const out = {};
  Object.keys(value).forEach((k) => {
    if (!SENSITIVE.has(k.toLowerCase())) out[k] = sanitizeSessionData(value[k], depth + 1);
  });
  return out;
};

// Chaine JSON -> chaine JSON nettoyee (inchangee si rien a retirer ou si ce n'est pas du JSON).
export const sanitizeJsonString = (raw) => {
  if (typeof raw !== 'string') return raw;
  try {
    const v = JSON.parse(raw);
    return hasSensitiveSessionData(v) ? JSON.stringify(sanitizeSessionData(v)) : raw;
  } catch (e) {
    return raw;
  }
};

// Lit un objet JSON stocke. S'il contient des champs sensibles (session ouverte avant la correction),
// reecrit la version nettoyee dans le stockage SANS toucher au jeton ni a la validite de la session.
// JSON invalide : l'exception est conservee (meme comportement qu'avant pour les appelants).
export const readCleanStoredJson = (key, storage = window.localStorage) => {
  const raw = storage.getItem(key);
  if (raw === null || raw === undefined) return null;
  const parsed = JSON.parse(raw);
  if (!hasSensitiveSessionData(parsed)) return parsed;
  const clean = sanitizeSessionData(parsed);
  try {
    storage.setItem(key, JSON.stringify(clean));
  } catch (e) {
    /* quota : la valeur nettoyee est quand meme retournee */
  }
  return clean;
};

export const readSessionUser = (storage) => readCleanStoredJson('@accessUser', storage);
